<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-02-23 13:54:22
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-04-25 20:27:23
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/user_home_page/components/MainPageCard.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>

  <div :class="customClass" class="bg-white  br-10 p-14 border-box text-left cardBox" style="position:relative;">
    <div class="controllBox">

      <div class="collect" @click="share">
        <i class="iconfont icon">{{`\ue6f5`}}</i>
      </div>
      <div class="collect" @click="collect">
        <i class="iconfont checkIcon" v-if="userInfo.isFollower">{{`\ue6e8` }}</i>
        <i class="iconfont icon" v-else>{{`\ue6d8` }}</i>
      </div>
    </div>
    <div class="d-flex a-center">
      <img class="flex-shrink-0  mr-5" :src="userBaseInfoVo.companyLogo" v-if="userBaseInfoVo.companyLogo" alt="" style="width: 21px;height: 21px;border-radius:4px;">
      <div class="text-ellipsis-overflow-1 cor-262626 fw-5 fz-11" style="width: 300px">{{userBaseInfoVo.companyName}}</div>
    </div>
    <div class="d-flex">
      <div class="d-flex flex-column flex-wrap" style="width: 190px;padding-top:7px;">

        <div class="" style="width: 190px;">
          <div class="d-flex a-center flex-wrap">
            <div class="mr-5 fz-19 fw-7 text-ellipsis-1 cor-262626" style="max-width: 158px;">
              {{ userBaseInfoVo.name }}
            </div>
            <!-- <div class="d-flex flex-center  border-box lh-11">
                <img v-if="userBaseInfoVo.isRealName" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/images/authGif/auth.gif" style="width: 17px; height: 17px;">
                <img v-else class="br-100 mr-5 p-relative" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/divs/no-realName.png" mode="" style="width: 17px; height: 17px; top: 1px">
              </div> -->
          </div>
          <div class="fz-14 cor-8C8C8C  text-ellipsis-1 mt-5" style="max-width: 190px">
            {{ userBaseInfoVo.position }}
          </div>
        </div>
        <div style="width: 190px;margin-top: auto;">
          <div class="d-flex a-center mt-7 cor-262626" v-if="userBaseInfoVo.phone">
            <div class="iconfont mr-5 fz-17">{{ `\ue737` }}</div>
            <div class="fz-14  text-ellipsis-1" style="width: 170px">{{userBaseInfoVo.phoneCountryCode}} {{userBaseInfoVo.phone}}</div>
          </div>
          <div class="d-flex a-center mt-5 cor-262626" v-if="userBaseInfoVo.email">
            <div class="iconfont mr-5 fz-17">{{ `\ue72f` }}</div>
            <div class="fz-14 text-ellipsis-1" style="width: 170px">{{ userBaseInfoVo.email }}</div>
          </div>

        </div>
      </div>
      <!-- 右边 -->
      <div class="ml-auto f-shrink d-flex flex-column p-relative mt-7">
        <img class="d-block" style="width: 100px; height: 100px" :src="userBaseInfoVo.vCardUrl" />
        <img class="" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/WeMeetQrcodeIcon.png" style="width: 61px; height: 15px; margin: 8px auto 0" />
      </div>
    </div>
    <div class="d-flex a-center mt-5 cor-262626" v-if="userBaseInfoVo.fullAddress">
      <div class="iconfont mr-5 fz-17">{{ `\ue729` }}</div>
      <div class="fz-14  text-ellipsis-1" style="width: 300px" @click="copyWord" id="copyWord" :data-clipboard-text="userBaseInfoVo.fullAddress">{{ userBaseInfoVo.fullAddress }}</div>
    </div>

    <div class="languageTips" v-if="userBaseInfoVo.language != 'CN'">
      {{language}}
    </div>
  </div>

</template>
<script>
// import NativeShare from 'nativeshare'
import Clipboard from 'clipboard'
import { contactAddFollower, cancelFollower } from '@/api/interNational'
export default {
  name: 'MainPageCard',
  props: {
    customClass: {
      type: String,
      default: '',
    },
    userBaseInfoVo: {
      type: Object,
      default: {},
    },
    userInfo: {
      type: Object,
      default: {},
    },
  },
  components: {},
  data() {
    return {
      nativeShare: {},
    }
  },
  computed: {
    language() {
      let lag = this.languageList.filter((v) => v.languageKey == this.userBaseInfoVo.language)
      console.log(lag)
      if (lag.length > 0) {
        return lag[0].name
      } else {
        return ''
      }
    },
    languageList() {
      return [
        { name: this.$t('lang.t267'), languageName: '中文', languageKey: 'CN', check: false },
        { name: this.$t('lang.t268'), languageName: 'English', languageKey: 'EN', check: false },
        { name: this.$t('lang.t269'), languageName: 'Français', languageKey: 'FR', check: false },
        { name: this.$t('lang.t270'), languageName: 'Русский', languageKey: 'RU', check: false },
        { name: this.$t('lang.t271'), languageName: 'Español', languageKey: 'ES', check: false },
        { name: this.$t('lang.t272'), languageName: '日本語', languageKey: 'JA', check: false },
        { name: this.$t('lang.t273'), languageName: '한국어', languageKey: 'KO', check: false },
        { name: this.$t('lang.t274'), languageName: 'Bahasa Indonesia', languageKey: 'ID', check: false },
        { name: this.$t('lang.t275'), languageName: 'Tiếng Việt', languageKey: 'VI', check: false },
        { name: this.$t('lang.t276'), languageName: 'Deutsch', languageKey: 'DE', check: false },
        { name: this.$t('lang.t277'), languageName: 'Türkçe', languageKey: 'TR', check: false },
        { name: this.$t('lang.t278'), languageName: 'Italiano', languageKey: 'IT', check: false },
        { name: this.$t('lang.t279'), languageName: 'Português', languageKey: 'PT', check: false },
        { name: this.$t('lang.t280'), languageName: 'ภาษาไทย', languageKey: 'TH', check: false },
        { name: this.$t('lang.t281'), languageName: 'Bahasa Melayu', languageKey: 'MS', check: false },
        { name: this.$t('lang.t282'), languageName: 'بالعربية', languageKey: 'AR', check: false },
      ]
    },
  },
  methods: {
    isWeixinBrowser() {
      const userAgent = navigator.userAgent.toLowerCase()
      return /micromessenger/.test(userAgent)
    },
    copyWord() {
      var _this = this
      var clipboard = new Clipboard('#copyWord')
      clipboard.on('success', (e) => {
        _this.$toast.success('地址已复制')
        //  释放内存

        clipboard.destroy()
      })

      clipboard.on('error', (e) => {
        console.log(e)
        // 不支持复制
        _this.$toast.fail('该浏览器不支持复制')
        // 释放内存
        clipboard.destroy()
      })
    },
    share() {
      if (this.isWeixinBrowser()) {
        this.$emit('wxshare')
        return false
      }
      try {
        this.nativeShare.call()
      } catch (err) {
        console.log(err)
      }
    },
    collect() {
      this.$isLogin().then((res) => {
        if (this.userInfo.isFollower) {
          // this.$dialog
          //   .alert({
          //     title: `取消关注`,
          //     message: `取消关注后，您将不会在动态中看到TA的发布的动态`,
          //     confirmButtonColor: '#00c4c9',
          //     confirmButtonText: `取消关注`,
          //     cancelButtonText: '再考虑一下',
          //     showCancelButton: true,
          //   })
          //   .then(() => {
          //     // on close

          //   })
          cancelFollower({}, this.userBaseInfoVo.weMeetUid).then((res) => {
            this.$toast(this.$t('lang.t147'))
            this.$emit('refresh')
          })
        } else {
          let params = {
            targetUid: this.userBaseInfoVo.weMeetUid,
          }
          contactAddFollower({}, params).then((res) => {
            this.$toast(this.$t('lang.t146'))
            this.$emit('refresh')
          })
        }
      })
    },
  },
  mounted() {
    this.nativeShare = new NativeShare()
    var shareData = {
      title: 'AI 荟客厅',
      desc: 'AI 荟客厅',
      // 如果是微信该link的域名必须要在微信后台配置的安全域名之内的。
      link: window.location.href,
      icon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/images/wemeet-logo.jpg',
    }
    this.nativeShare.setShareData(shareData)
  },
}
</script>


<style lang="less" scoped>
.cardBox {
  position: relative;
  .languageTips {
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 12px;
    background: #d1feff;
    border-bottom-right-radius: 10px;
    border-top-left-radius: 10px;
    padding: 0 7px;
    box-sizing: border-box;
    color: #00c4c9;
  }
}
.controllBox {
  position: absolute;
  top: -10px;
  right: 0px;
  display: flex;
  .collect {
    width: 32px;
    height: 32px;
    background: #fff;
    align-items: center;
    display: flex;
    justify-content: center;
    border-radius: 50%;
    margin-right: 5px;
    .icon {
      font-size: 24px;
      color: #333;
    }
    .checkIcon {
      color: #00c4c9;
      font-size: 24px;
    }
  }
}
</style>

